import React from 'react';
import { Layout } from '../components/Layout';
import { Products as ProductsSection } from '../components/Products';
export const ProductsPage = () => {
  return <Layout data-id="element-321">
      <div className="pt-32 bg-pattern-dark min-h-screen" data-id="element-322">
        <div className="container mx-auto px-4" data-id="element-323">
          <div className="text-center mb-16" data-id="element-324">
            <h1 className="font-display italic text-4xl sm:text-6xl font-bold mb-6 text-white" data-id="element-325">
              Premium <span className="text-red-500" data-id="element-326">Products</span>
            </h1>
            <p className="font-body italic text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-327">
              Copywrite needed
            </p>
          </div>
        </div>
        <ProductsSection showAllDetails={true} data-id="element-328" />
      </div>
    </Layout>;
};